<template>
    <div>
        <div class="page-top mb-1 mb-3 clearfix">
            <h1 class="float-left"> Report Details </h1>
        </div>
        <div class="tab-content" id="myTabContent">
            <div>
                <div class="mt-3 mb-3 tbl-fiters-search-area  hidden-xs">
                    <div class="field-box export-attendance">
                        <button class="btn btn-primary export" @click="exportReport">Export Report</button>
                    </div>
                </div>


                <div class="tab-pane fade show active" id="" role="tabpanel" aria-labelledby="new-tab">
                    <table id="vendorReportTable" class="table" style="width:100%">
                        <thead>
                        <tr>
                            <th style="display: none">ID</th>
                            <th>Branch Code</th>
                            <th>Student Name</th>
                            <th>Deposit Slip No.</th>
                            <th>Collection Date</th>
                            <th>Mode of Payment</th>
                            <th>Instrument No.</th>
                            <th>Amount</th>
                            <th>Credit Date</th>
                            <th>Roll No</th>
                            <th>Branch Name</th>
                        </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    var dtTable = null;
    export default {
        data() {
            return {

            };
        },
        mounted() {
            this.getVoucherReport();
        },
        methods: {
            getVoucherReport: function(){
                this.$Progress.start();
                var that = this;
                var date = this.$route.params['date'];
                dtTable = $('#vendorReportTable').DataTable({
                    sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "/api/reportDetails",
                        "data": function (d) {
                            d.date = date;
                        },
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {render: function(data,type,full){
                                return '0001';
                            }},
                        {render: function(data,type,full){
                                if(full.student.name != null){
                                    return full.student.name;
                                }else{
                                    return "---";
                                }
                            }},
                        {render: function(data,type,full){
                                if(full.unique_identifier != null){
                                    return full.unique_identifier;
                                }else{
                                    return "---";
                                }
                            }},
                        {render: function(data,type,full){
                                if(full.transaction_date != null){
                                    return moment(full.transaction_date).format('YYYY-MM-DD');
                                }else{
                                    return "---";
                                }
                            }},
                        {render: function(data,type,full){
                                return 'IBFT';
                            }},
                        {render: function(data,type,full){
                                if(full.transaction_number != null){
                                    return full.transaction_number;
                                }else{
                                    return "---";
                                }
                            }},
                        {render: function(data,type,full){
                                if(full.amount != null){
                                    return full.amount;
                                }else{
                                    return "---";
                                }
                            }},
                        {render: function(data,type,full){
                                if(full.transaction_date != null){
                                    return moment(full.transaction_date).format('YYYY-MM-DD');
                                }else{
                                    return "---";
                                }
                            }},
                        {render: function(data,type,full){
                                if(full.student.student_id != null){
                                    return full.student.student_id;
                                }else{
                                    return "---";
                                }
                            }},
                        {render: function(data,type,full){
                                return 'FINJA';
                            }},
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (res) => {
                        that.hasPer = true;
                        that.showBtn = true;
                        setTimeout(function(){
                            $('select.selectpicker').selectpicker();
                        },300);
                        that.$Progress.finish();
                    }
                });
            },
            exportReport: function(){
                console.log(this.$route.params['date']);
                var that = this;
                that.$Progress.start();
                var formData = {
                    'date': this.$route.params['date'],
                }
                axios.post('/api/reportDetailsExport', formData,{
                    responseType: 'blob'
                })
                    .then(res => {
                        if(res.status == 200){
                            const url = URL.createObjectURL(new Blob([res.data], {
                                type: 'application/vnd.ms-excel'
                            }))

                            const link = document.createElement('a')
                            link.href = url
                            link.setAttribute('download', 'misReportDetails.xls')
                            document.body.appendChild(link)
                            link.click()
                            //that.$Progress.finish();
                        }else{
                            //that.$Progress.fail();
                            that.showAlertBox('error','Error to load data');
                        }
                    })
                    .catch(err => {
                        //that.$Progress.fail();
                        that.showAlertBox('error','Error to load data');
                    });
            },
        },
        created() {
            //
        }
    }
</script>
